import { useMemberStatus } from '@/store/people/hooks';
import { Chip } from '@heroui/react';

export function MemberStatusLabel({ id }: { id?: string }) {
  const label = useMemberStatusLabel(id);

  return <div>{label}</div>;
}

export function MemberStatusChip({
  id,
  className = '',
}: {
  id?: string;
  className?: string;
}) {
  const label = useMemberStatusLabel(id);

  if (!label) {
    return null;
  }

  return (
    <Chip
      size='sm'
      radius='full'
      variant='flat'
      className={`h-5 min-h-5 shrink-0 rounded-full px-2 text-[10px] font-semibold uppercase tracking-wide text-default-600 ${className}`}
    >
      {label}
    </Chip>
  );
}

function useMemberStatusLabel(id?: string) {
  const { lookup } = useMemberStatus();

  if (!id) {
    return '';
  }

  return lookup[id]?.label || '';
}
